const { __ } = wp.i18n;
/**
 * Dropdown block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Content navigator", "uipress-lite"),
  moduleName: "uip-content-navigator",
  description: __("Creates a navigatable file tree of all your site content like posts, pages and media. Allows for creation of new folders and organisation of content", "uipress-lite"),
  group: "dynamic",
  icon: "folder_open",
};
